// Class: openfl.events.IEventDispatcher

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var IEventDispatcher = function() {}

// Meta

IEventDispatcher.__name__ = "openfl.events.IEventDispatcher";
IEventDispatcher.__isInterface__ = true;
IEventDispatcher.prototype = {
	
};
IEventDispatcher.prototype.__class__ = IEventDispatcher.prototype.constructor = $hxClasses["openfl.events.IEventDispatcher"] = IEventDispatcher;

// Init



// Statics




// Export

exports.default = IEventDispatcher;